const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank');
  if (newWindow) {
    newWindow.focus();
  } else {
    // Fallback if new tab or window is blocked by the browser
    window.location.href = url;
  }
};

// eslint-disable-next-line import/prefer-default-export
export { openInNewTab };
